<!-- BACK TO TOP -->
<div id="back-top" #backTopDiv style="z-index: 1000" *ngIf="visible">
  <button mat-mini-fab (click)="toTop()">
    <mat-icon>keyboard_arrow_up</mat-icon>
  </button>
  <!--  <a href="" title="Topo" (click)="toTop()">-->
  <!--    <img src="images/topo.svg" alt="Topo"/>-->
  <!--  </a>-->
</div>
